import { saveAs } from "file-saver";

import { getString } from "../../logic/strings";
import type { GlobalState } from "../../types/stateTypes";
import { buildExportBundle } from "./buildExportBundle";

export function saveOpenlifterFile(global: GlobalState, onWrpfDownloaded?: (at: string) => void): void {
  let meetname = global.meet.name;
  if (meetname === "") {
    meetname = getString("common.unnamed-filename", global.language);
  }
  meetname = meetname.replace(/ /g, "-");

  const state = JSON.stringify(buildExportBundle(global));
  const blob = new Blob([state], { type: "application/json;charset=utf-8" });
  saveAs(blob, `${meetname}.openlifter`);

  if (global.wrpfSession.tournamentId && onWrpfDownloaded) {
    onWrpfDownloaded(new Date().toISOString());
  }
}
